module.exports = __webpack_public_path__ + "img/team1.a71a63ba.png";